import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'
import { EliminarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdGrupoContableExistenciasFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  gruposContablesExistencias,
  actualizarGruposContablesExistencias
}) => {
  const [mostrarSeleccionarCuentaModal, setMostrarSeleccionarCuentaModal] = React.useState(false)
  const [mostrarEliminarCuentaModal, setMostrarEliminarCuentaModal] = React.useState(false)
  const [dataGrupoContable, setDataGrupoContable] = React.useState(null)

  React.useEffect(() => {
    if (gruposContablesExistencias.length === 1) {
      values.cuentaContableExistencias = gruposContablesExistencias[0]._id
      setValues(values)
    }
  }, [gruposContablesExistencias, values, setValues])

  const onSuccess = React.useCallback(async () => {
    actualizarGruposContablesExistencias()
    setMostrarSeleccionarCuentaModal(false)
  }, [actualizarGruposContablesExistencias])

  const clickEliminarGrupoContable = React.useCallback(() => {
    const found = gruposContablesExistencias.find(x => x._id === values.cuentaContableExistencias)
    if (!found) return
    TablaPersonalizadaService.getAsEdicion(found.id).then(({ data }) => {
      setDataGrupoContable(data)
      setMostrarEliminarCuentaModal(true)
    })
  }, [values, gruposContablesExistencias])

  return (
    <>
      <Form.Group>
        <Form.Label text='EXISTENCIAS' htmlFor='select-gContablesExistencias' sm={2} md={3} lg={2} alignRightAt='sm' />
        <Col sm={10} md={9} lg={10}>
          <Form.InputGroup>
            <Field name='cuentaContableExistencias'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-gContablesExistencias'
                >
                  <option value=''>Seleccionar</option>
                  {gruposContablesExistencias &&
                    gruposContablesExistencias.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarSeleccionarCuentaModal(true)}>+</Button>
              <Button className='bg-danger border border-danger' onClick={() => clickEliminarGrupoContable()}>
                -
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarSeleccionarCuentaModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarSeleccionarCuentaModal(false)}
          show={mostrarSeleccionarCuentaModal}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA}
        />
      )}
      {mostrarEliminarCuentaModal && (
        <EliminarTablaPersonalizadaModal
          handleClose={e => setMostrarEliminarCuentaModal(false)}
          show={mostrarEliminarCuentaModal}
          modalData={dataGrupoContable}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA}
        />
      )}
    </>
  )
}

export default React.memo(IdGrupoContableExistenciasFormGroup)
